export const white = {
  5: 'rgba(255,255,255,0.05)',
  10: 'rgba(255,255,255,0.1)',
  20: 'rgba(255,255,255,0.2)',
  30: 'rgba(255,255,255,0.3)',
  40: 'rgba(255,255,255,0.4)',
  50: 'rgba(255,255,255,0.5)',
  60: 'rgba(255,255,255,0.6)',
  80: 'rgba(255,255,255,0.8)',
  100: '#FFFFFF'
};
